import {redirect} from 'react-router-dom';
import {store as AppStore} from '../store/store';
import {markOnboardingComplete, removeAccount} from '../store/slices/me_slice';
import {signOutLoader} from '../loaders/signout_loader';
import {storeProfileData} from './partials/store_profile_data';

export async function privacyAgreementAction(store: typeof AppStore, request: Request) {
    const token = store.getState().exchangeToken.token;
    if (token) {
        switch (request.method) {
            case 'PUT': {
                const formData = await request.formData();
                await storeProfileData(store, token, formData);
                await store.dispatch(markOnboardingComplete({token}));
                return redirect('/');
            }
            case 'DELETE': {
                await store.dispatch(removeAccount({token}));
                return signOutLoader(store);
            }
        }
    }

    throw new Response('', {status: 405});
}
